import React from 'react';
import ProductPatternPage from './ProductPatternPage';
import './YardLongBeanPage.css';
import yardlongbeanLogo from '../images/yardlongbean-logo.png';
import ds707 from '../images/yardlongbeans-ds707-img.png';

const varieties = [
  {
    name: 'DS-707',
    image: ds707,
    description: [
      'Dynasty Agriseeds DS-707 Yardlong beans seeds have vigorous plant',
      'Good heat tolerance',
      'Iris Hybrid Yardlong beans has firm pod',
      'Color: Attractive green',
      'Germination: 70%',
      'Length: 55-60 cm',
      'Sowing season: All seasons',
      'First harvest: 50-52 days after sowing Iris Yardlong Beans',
    ],
  },
 
];

export default function YardLongBeanPage() {
  return (
    <ProductPatternPage
      title="Yardlong Bean"
      varieties={varieties}
      pageClass="yardlongbean-page"
      heroImage={yardlongbeanLogo}
    />
  );
}
